module.exports = __webpack_public_path__ + "img/affilate-img.b1f2506a.svg";